export const LOCAL_CONSTANTS = {
  accountStatus: "Account Status",
  areYouSure: "Are you sure?",
  areYouSureRestrictUserAccess: "Are you sure you want to restrict access for this user?",
  removePromo: "Are you sure you want to remove this promo",
  removeCoupon: "Are you sure you want to remove this coupon",
  removeBlog: "Are you sure you want to remove this blog",
  removeFAQ: "Are you sure you want to remove this faq",
  pendingBlog: "Are you sure you want to approve/reject this blog",
  approvedBlog: "Are you sure you want to reject this blog",
  rejectBlog: "Are you sure you want to approve this blog",
  approveComment: "Are you sure you want to approve this comment",
  noPromoFound: "No promo found",
  noCouponFound: "No coupon found",
  noBlogFound: "No blog found",
  ascKey: 1,
  dateFormat: "D MMM YYYY",
  descKey: -1,
  errorOnUpdatingUser: "There is some error updating the user",
  limitCount: 50,
  loading: "Loading",
  na: "N/A",
  no: "No",
  ZOLVE_ROLES: [
    { value: "1", label: "ADMIN" },
    { value: "2", label: "ACCOUNTANT" },
    { value: "3", label: "LOGISTICS" },
    { value: "4", label: "DISPATCH" },
    { value: "5", label: "DOT" }
  ],
  paymentOrderStatus: [
    {
      value: 1,
      label: "Pending",
    },
    {
      value: 2,
      label: "Success",
    },
    {
      value: 3,
      label: "Failed",
    },
  ],
  paymentStatus: [
    {
      value: 1,
      label: "Pending",
    },
    {
      value: 2,
      label: "Success",
    },
    {
      value: 3,
      label: "Failed",
    },
    {
      value: 4,
      label: "Processing",
    },
  ],
  paymentsTableHeaders: [
    { value: "user.fullName", label: "Name" },
    { value: "user.email", label: "Email" },
    { value: "user.phone", label: "Phone Number" },

    { value: "bundle.name", label: "Bundle Name" },
    { value: "date", label: "Date" },
    { value: "orderStatus", label: "Order Status" },
    { value: "paymentStatus", label: "Payment Status" },
    { value: "currency", label: "Currency" },
    { value: "price", label: "Price" },
    { value: "qty", label: "Quantity" },
    { value: "url", label: "URL" },
    { value: "action", label: "Action" },
  ],
  updatingUser: "Updating User",
  userBlockedSuccessfully: "User Blocked successfully",
  usersTableHeaders: [
    { value: "fullName", label: "Name" },
    { value: "phoneNumber", label: "Phone Number" },
    { value: "email", label: "Email" },
    { value: "createdAt", label: "Date" },
    { value: "role", label: "Role" },

    { value: "isBlocked", label: "Blocked" },
    { value: "actions", label: "Actions" },
  ],
  zolveusersTableHeaders: [{ value: "fullName", label: "Name" },
  { value: "phoneNumber", label: "Phone Number" },
  { value: "email", label: "Email" },
  { value: "address", label: "Address" },
  { value: "passport", label: "Passport Front" },
  { value: "passport", label: "Passport Back" },
  { value: "createdAt", label: "Created At" }],

  logisticsRequestsTableHeaders: [
    { value: "transId", label: "Transaction ID" },
    { value: "orderId", label: "Order ID" },
    { value: "status", label: "Status" },
    { value: "orderStatus", label: "Order Status" },
    { value: "kycStatus", label: "KYC Status" },
    { value: "awbNo", label: "AWB No" },
    { value: "name", label: "Name" },
    { value: "email", label: "Email" },
    { value: "phone", label: "Phone" },
    { value: "createdAt", label: "Created At" },
  ],

  iccidTableHeaders: [
    { value: "brand", label: "Brand" },
    { value: "iccid", label: "iccid" },
    { value: "Warehouse Name", label: "Warehouse Name" },
    { value: "createdAt", label: "Date" },
    { value: "status", label: "Status" },

    { value: "type", label: "Type" },
  ],
  CustomersTableHeaders: [
    { value: "Order Id", label: "Order Id" },
    { value: "Sim Type", label: "Sim Type" },
    { value: "Sim Number", label: "Sim Number" },
    { value: "Order Type", label: "Order Type" },
    { value: "Email", label: "Email" },
    // { value: "Phone Number", label: "Phone Number" },
    { value: "Status", label: "Status" },
    { value: "Plan", label: "Plan" },
    { value: "Quantity", label: "Quantity" },
    { value: "ICCID", label: "ICCID" },
    { value: "Logistics", label: "Logistics" },
    { value: "Transaction Date", label: "Transaction Date" },
    { value: "Travel Date", label: "Travel Date" },
    { value: "Action", label: "Action" },
    { value: "Passport Front", label: "Passport Front" },
    { value: "Passport Back", label: "Passport Back" },
    { value: "Visa", label: "Visa" },

    { value: "Name", label: "Name" },
    { value: "Phone", label: "Phone" },
    { value: "City", label: "City" },
    { value: "Pincode", label: "Pincode" },
    { value: "State", label: "State" },
    { value: "Brand", label: "Brand" },
    { value: "DOB", label: "DOB" },
    { value: "Address Line 1", label: "Address Line 1" },
    { value: "Address Line 2", label: "Address Line 2" },
  ],

    BundleTableHeaders :[
    { value: "Plan Name", label: "Plan Name" },
    { value: "Brand", label: "Brand" },
    { value: "Plan Code", label: "Plan Code" },
    { value: "Sim Type", label: "Sim Type"},
    { value: "Country", label: "Country" },
  ],

    ActivationRequestTableHeaders :[
    { value: "Name", label: "Name" },
    { value: "Email", label: "Email" },
    { value: "Eid", label: "Eid"},
    { value: "Imei", label: "Imei" },
    { value: "Phone Number", label: "Phone Number" },
    { value: "Zip Code", label :"Zip Code"},
    { value: "ICCID", label :"ICCID"},    
    { value: "Plan", label :"Plan"}, 
    { value: "Price", label :"Price"}, 
    { value: "Duration", label :"Duration"}, 
    { value: "Status", label :"Status"},   
    { value: "Order Id", label: "Order Id" },
    { value: "Order Type", label: "Order Type" },
    { value: "Sim Type", label: "Sim Type" },
    { value: "Travel Date", label: "Travel Date" },
    { value: "Sim Activation Date", label: "Sim Activation Date" },
    { value: "Payment Date", label: "Payment Date" },
    { value: "Created Date", label: "Created Date" },
    { value: "Stripe Customer ID", label: "Stripe Customer ID" },
    { value: "Activate Phone Number", label: "Activate Phone Number" },
  ],

    InventoryTableHeaders :[
    { value: "Plan Name", label: "Plan Name" },
    { value: "Plan Variant", label: "Plan Variant" },
    { value: "ICCID Count", label: "ICCID Count" },


  ],

  rolesTableHeaders: [
    { value: "title", label: "Title" },
    { value: "partner", label: "Partner" },
    // { value: "email", label: "Email" },
    { value: "createdAt", label: "Date" },
    // { value: "isEmailVerified", label: "Email Verified" },
    // { value: "isPhoneNoVerified", label: "Mobile No Verified" },

    // { value: "isBlocked", label: "Blocked/Unblocked" },
    { value: "actions", label: "Actions" },
  ],
  subadminTableHeaders: [
    { value: "fullName", label: "Full Name" },
    { value: "email", label: "email" },
    { value: "partnerWebsiteId", label: "Partner Website" },
    { value: "role", label: "Role" },
    { value: "createdAt", label: "Created At" },
    { value: "actions", label: "Actions" },

  ],

  userUnblockedSuccessfully: "User unblocked successfully",
  yes: "Yes",
  promosTableHeaders: [
    { value: "promoCode", label: "Promo Code" },
    { value: "title", label: "Title" },
    { label: "Promo type" },
    { value: "discount", label: "Discount" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "Expiry Date" },
    { label: "Actions" },
  ],
  promosTableHeadersssss: [
    { value: "promoCode", label: "Promo Code" },
    { value: "title", label: "Title" },
    { label: "Promo type" },
    { value: "discount", label: "Discount" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "Expiry Date" },
    // { label: "Actions" },
  ],
  couponTableHeaders: [
    { value: "couponCode", label: "Coupon Code" },
    { value: "title", label: "Title" },
    { label: "Coupon type" },
    { value: "discount", label: "Discount" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "Expiry Date" },
    { label: "Actions" },
  ],
  blockedAccounts: [
    { value: null, label: "Select Account status" },
    { value: true, label: "blocked" },
    { value: false, label: "Unblocked" },
  ],
  blogTypes: [
    { value: null, label: "Select Blog Type" },
    { value: 1, label: "Created by Admin" },
    { value: 2, label: "Created by Users" },
  ],
  blogStatus: [
    { value: null, label: "Select Blog Status" },
    { value: 1, label: "Pending" },
    { value: 2, label: "Approved" },
    { value: 3, label: "Rejected" },
  ],
  phoneNoVerified: [
    { value: null, label: "Select Phone No Verification Status" },
    { value: true, label: "Verified" },
    { value: false, label: "Unverified" },
  ],
  emailVerified: [
    { value: null, label: "Select Email Verification Status" },
    { value: true, label: "Verified" },
    { value: false, label: "Unverified" },
  ],
  loyalityTableHeaders: [
    { value: "fullName", label: "User Name" },
    { value: "priceBeforeLoyality", label: "Actual Price" },
    { value: "priceAfterLoyality", label: "New Price" },
    { value: "quantity", label: "Quantity" },
    { value: "loyalityPoint", label: "Loyality Point" },
    { value: "createdAt", label: "Purchased At" },
  ],
  blogsTableHeaders: [
    { label: "Image" },
    { label: "Title" },
    { value: "status", label: "Status" },
    { value: "rating", label: "Rating" },
    { value: "userFullName", label: "Created By" },
    { value: "createdAt", label: "Created At" },
    { label: "Actions" },
  ],
  faqTableHeaders: [
    { label: "Question" },
    { label: "CreatedAt" },
    { label: "Actions" },
  ],
  countryPlansHeaders: [
    { label: "Popular Countries" },
    { label: "Plan name" },
    { label: "Vendor" },
    { label: "Description" },
    { label: "Product Code" },
    { label: "Validity" },
    { label: "Data" },
    { label: "Network" },
    { label: "Plan Amount" },
    { label: "Retail Amount" },
    { label: "Offer Amount" },
    { label: "Buy Amount" },
    { label: "Margin Price" },
    { label: "Margin %" },
    { label: "Total Sales" },
    { label: "Popular Plan" },
    { label: "Enable / Disable" },
    { label: "Document Required ?" }
  ],
  partnerCountryPlansHeaders: [
    { label: "Display Name" },
    { label: "Vendor" },
    { label: "Description" },
    { label: "Validity" },
    { label: "Data" },
    { label: "Enable / Disable" },
  ],
  PARTNERS: {
    COMMBITZ: "commbitz",
    NIYO: "niyo",
    VFS: "vfs",
    TRAVELTHRU: "travelthru",
    GLOBALTIX: "globaltix",
    VFSPHILLI: "vfs-phillip",
    BHASIN:
      "basin travels",
    AIRINDIA: "airindia",
    HOSHI: "azgo",
    ASEGO: "asego",
    AZGO: "hoshi",
  },
  ROLES: {
    COMMBITZ_USER: 2,
    NIYO_USER: 4,
    VFS_USER: 5,
    TRAVELTHRU_USER: 6,
    GLOBALTIX: 7,
    VFS_PHILIP_USER: 8,
    BHASIN_TRAVEL_USER: 11,
    AIR_INDIA_USER: 9,
    HOSHI: 12,
    AZGO: 15,
    ASEGO: 14,
  },
  LASTPATHNAME: {
    VENDOR_API: "vendor_api",
    SANDBOX_PLANS: "sandbox-plans"
  },
  PARTNERTYPES: {
    COMMBITZ: 1,
    NIYO: 2,
    VFS: 3,
    TRAVELTHRU: 4,
    GLOBALTIX: 5,
    BHASIN_TRAVEL: 6,
    AIR_INDIA: 7,
    HOSHI: 8,
    ASEGO: 9,
    AZGO: 10
  },
};
